import Reservation from '../../components/Reservation/Reservation';
import {connect} from 'react-redux';
import reservationActions from '../../actions/reservationActions';
import {bindActionCreators} from 'redux';

function mapStateToProps(state) {
  return {
    reservation: state.reservation.reservation,
    isNewlyCanceled: state.reservation.newlyCanceled,
    organization: state.organization.organization
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setReservationStatusRequest: bindActionCreators(reservationActions.actions.setReservationStatusRequest, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Reservation);



// WEBPACK FOOTER //
// ./containers/Reservation/Reservation.js